module.exports = __webpack_public_path__ + "static/media/noimg.bdd113c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/console/images/noimg.png
// module id = 1572
// module chunks = 0